


import AnimalSighting from '../modules/AnimalSighting/AnimalSighting';
import DataRequest from '../modules/DataExtraction/DataRequest/DataRequest';
import HighChartsDarkTheme from './HighChartsDarkTheme';
import HighChartsLightTheme from './HighChartsLightTheme';

const themeStyles = {
    PermitDashboard: {
        div: {
            "border-color": { dark: "#ffffff", light: "#000000" },
            "color": { dark: "#dadada", light: "#606060" }
        }
    },

    AirQuality: {
        div: {
            "border-color": { dark: "#ffffff" },
            "color": { dark: "#dadada", light: "#606060" }
        },

        h6: {
            "border-color": { dark: "#ffffff", light: "#000000" },
            "color": { dark: "#ffffff", light: "#525252" }
        },
        span: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#004987" }
        },
        hr: {
            "border-color": { dark: "#e7e7e7", light: "#7f7e7e" }
        }
    },
    MWQ: {
        hr: {
            "border-color": { dark: "#e7e7e7", light: "#7f7e7e" }
        }
    },
    PermitAssessment: {
        p: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#004987" }
        },
    },
    DataRequest: {
        span: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#004987" }
        },
        div: {
            "borderColor": { dark: "#fff", light: "" }
        },

    },
    DataRequestReview: {
        span: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#004987" }
        }

    },
    PermitDetailsPreview: {
        div: {
            "borderColor": { dark: "#ffffff", light: "" }
        }
    },

    TREnvironmentalAssessment: {
        div: {
            "borderColor": { dark: "#ffffff", light: "" }
        }
    },
    ApplicationCard: {
        h4: {
            "color": { dark: "#ffffff", light: "" }
        },
        div: {
            "background-color": { dark: "#404040", light: "#ffffff" }
        }
    },
    AnimalSighting: {
        div: {
            "borderColor": { dark: "#ffffff", light: "" }
        },
        span: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#004987" }

        }

    },
    Feedback: {
        div: {
            "color": { dark: "#ffffff", light: "#000000" },
            "background-color": { dark: "#2b2b2b", light: "#edf0f2" }
        },
        ".emoji-box": {
            "background-color": { dark: "blue", light: "green" },
            "color": { dark: "#ffffff", light: "#000000" },
        },
        p: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        span: {
            "color": { dark: "#ffffff", light: "blue" }
        },
        label: {
            "color": { dark: "#ffffff", light: "blue" }
        },
        input: {
            "background-color": { dark: "#606162", light: "#ffffff" },
            "color": { dark: "#ffffff", light: "#000000" },

        },
        input1: {
            "background-color": { dark: "#606162", light: "#ffffff" },
            "color": { dark: "#ffffff", light: "#000000" },

        },
        textarea: {
            "background-color": { dark: "#606162", light: "#ffffff" },

            "color": { dark: "#ffffff", light: "#000000" }
        },
        button: {
            "color": { dark: "#ffffff", light: "#000000" }
        }
    },
    eDraw: {
        button: {
            "color": { dark: "#ffff", light: "##046067" }
        }
    },
    EnvironmentalSnapshotReports:
    {
        div: {
            "border-color": { dark: "#ffffff", light: "#000000" },
            "color": { dark: "#dadada", light: "#606060" }
        },
        p: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
        span: {
            "color": { dark: "#ffffff", light: "#2D787F" }
        },
    },
    SidebarMobileHeader: {
        div: {
            "color": { dark: "#ffffff", light: "#575353" }
        },
        svg: {
            "color": { dark: "#ffffff", light: "#575353" }
        }
    },
    MetaData: {
        svg: {
            "color": { dark: "#ffffff", light: "#2e2e2e" }
        }
    },
    Copyrights: {
        h4: {
            "color": { dark: "#ffffff", light: "#353333" }
        },
        h6: {
            "color": { dark: "#ffffff", light: "#353333" }
        }
    },
    PrivacyPolicy: {
        h4: {
            "color": { dark: "#ffffff", light: "#353333" }
        },
        h6: {
            "color": { dark: "#ffffff", light: "#353333" }
        },
        p: {
            "color": { dark: "#c1c1c1", light: "#717171" }
        }
    },
    TermsCondition: {
        h4: {
            "color": { dark: "#ffffff", light: "#353333" }
        },
        h6: {
            "color": { dark: "#ffffff", light: "#353333" }
        },
        p: {
            "color": { dark: "#c1c1c1", light: "#717171" }
        },
        ul: {
            "color": { dark: "#c1c1c1", light: "#717171" }
        }
    },
    Header: {
        div: {
            "color": { dark: "#ffffff", light: "#000000" }
        },
    }
};


const applyTheme = (elementInstances, theme, moduleName) => {
    if (!themeStyles[moduleName]) return; // Exit if module is not defined
    if (Object.values(elementInstances).length == 0) return;
    Object.values(elementInstances).forEach((el) => {
        if (el == undefined) return;
        const tagName = el?.tagName.toLowerCase();
        const inlineStyles = el.getAttribute("style"); // Get inline styles as a string

        //if (!inlineStyles) return; // Skip if no inline styles

        //const stylesArray = inlineStyles.split(";").map(style => style.trim()).filter(Boolean); // Split styles into an array & remove empty values
        let stylesArray = [];

        if (inlineStyles) {
            stylesArray = inlineStyles
                .split(";")
                .map(style => style.trim())
                .filter(Boolean);
        } else if (tagName && themeStyles[moduleName][tagName]) {
            // Fallback: use keys from themeStyles if inline styles not found
            stylesArray = Object.keys(themeStyles[moduleName][tagName]).map(key => `${key}:`);
        }
        stylesArray.forEach((style) => {
            const [property, value] = style.split(":").map(s => s.trim()); // Extract property & value

            // Apply theme styles only if the property exists in themeStyles for the given module and tag
            const tagName = el.tagName.toLowerCase();
            if (themeStyles[moduleName][tagName] && themeStyles[moduleName][tagName][property]) {
                // el.style[property] = themeStyles[moduleName][tagName][property][theme];
                const value = themeStyles[moduleName][tagName][property][theme];
                el.style.setProperty(property, value, "important");
            }
        });
    });
};

const updateAllCharts = (chartInstances, theme, t) => {

    const chartsArray = Array.isArray(chartInstances) ? chartInstances : Object.values(chartInstances);


    chartsArray.forEach((chart) => {
        if (chart && chart.update) {
            const isGaugeChart = chart.options?.chart?.type === 'solidgauge';
            // chart.update(theme === "dark" ? darkTheme : lightTheme, true, true);
            if (chart.options == undefined) return
            chart.update(theme === "dark" ? HighChartsDarkTheme : HighChartsLightTheme, true, true);
            if (isGaugeChart) {
                chart.update({
                    yAxis: {
                        lineWidth: 0, // removes the axis line around the gauge
                        tickWidth: 0, // Removes the tick marks
                        tickLength: 0,
                        labels: {
                            enabled: false
                        }
                    }
                }, true, true);
            }
            const exportingOptions = chart.options.exporting || {};

            const existingContextButton = exportingOptions.buttons?.contextButton || {};


            const existingText = existingContextButton.text || '';

            // Dynamically update only the stroke color inside the SVG <path>
            const updatedText = existingText
                .replace(/color:\s*#[0-9a-fA-F]+/g, `color: ${theme === 'dark' ? '#ffffff' : '#000000'}`) // Update color in <span>
                .replace(/stroke="[^"]*"/g, `stroke="${theme === 'dark' ? '#ffffff' : '#757474'}"`); // Update stroke color in <svg>

            // Remove trailing `color: #xxxxxx;` only if it appears **at the end of the string**
            const cleanedText = updatedText.replace(/color:\s*#[0-9a-fA-F]+;?\s*(<\/span>)?$/, '$1');
            // Update the theme dynamically
            const updatedExporting = {
                ...exportingOptions,
                buttons: {
                    contextButton: {
                        ...exportingOptions.buttons?.contextButton,
                        text: cleanedText,
                        symbolStroke: theme === 'dark' ? "#FFFFFF" : "#000000",
                        theme: {
                            r: 6,
                            fill: 'transparent',
                            stroke: theme === 'dark' ? '#ffffff' : '#bababa',
                            style: {
                                color: theme === 'dark' ? "#FFFFFF" : "#000000"
                            }
                        },
                    },
                },
            };

            // Apply the update
            chart.update({ exporting: updatedExporting }, true, true);

        }
    });

}

// Function to update general theme-based icons
const updateImages = (theme) => {
    document.querySelectorAll("img[data-theme-img]").forEach((img) => {
        const regionKey = img.getAttribute("data-theme-img");
        img.src = getImageSrc(regionKey, theme);
    });
};

// Function to get the correct image source for regions and measurement icons
const getImageSrc = (key, theme) => {
    const imageMap = {
        "Al Dhafra": { dark: "greyCirclePermitWhite.svg", light: "greyCirclePermit.svg" },
        "Abu Dhabi": { dark: "blueCirclePermitwhite.svg", light: "blueCirclePermit.svg" },
        "Al Ain": { dark: "orangeCirclePermitwhite.svg", light: "orangeCirclePermit.svg" },
        "MeasurementArea": { dark: "areadark.svg", light: "area.svg" },
        "MeasurementDistance": { dark: "distancedark.svg", light: "distance.svg" },
        "MeasurementLocation": { dark: "locationdark.svg", light: "location.svg" },
        "MeasurementReset": { dark: "resetDark.svg", light: "reset.svg" },
        "Excellent": { dark: "excellent-dark.svg", light: "excellent.svg" },
        "Good": { dark: "good-dark.svg", light: "good.svg" },
        "Neutral": { dark: "neutral-dark.svg", light: "neutral.svg" },
        "Poor": { dark: "poor-dark.svg", light: "poor.svg" },
        "VeryPoor": { dark: "verypoor-dark.svg", light: "verypoor.svg" },
        "polygon": { dark: "DarkPolygon-buffer.svg", light: "polygon.svg" },
        "point": { dark: "Drakpoint-buffer.svg", light: "point-buffer.svg" },
        "distance": { dark: "darkDistane-buffer.svg", light: "distance-buffer.svg" },
        "aoi-pointBuffer": { dark: "edraw-pinDark.svg", light: "point-buffer.svg" },
        "aoi-distanceBuffer": { dark: "distancedark.svg", light: "distance-buffer.svg" },
        "aoi-PolygonBuffer": { dark: "aoiPolyNewDark.svg", light: "aoiPolyNew.svg" },
        "aoi-polygon": { dark: "aoi-polyDark.svg", light: "aoi-polyLight.svg" },
        "edPolyline": { dark: "edraw-polylineDark.svg", light: "edraw-polyline.svg" },
        "edPolygon": { dark: "edraw-poligonDark.svg", light: "edraw-poligon.svg" },
        "edCircle": { dark: "edraw-cirDark.svg", light: "edraw-cir.svg" },
        "edExtent": { dark: "edraw-extDark.svg", light: "edraw-extent.svg" },
        "edText": { dark: "edraw-textDark.svg", light: "edraw-text.svg" },
        "mapPolygonBuffer": { dark: "aoiPolyNewDark.svg", light: "aoiPolyNew.svg" },
    };

    return `${process.env.PUBLIC_URL}/images/${imageMap[key]?.[theme] || "default.svg"}`;
};

export { applyTheme, updateAllCharts, updateImages }